const PERMISSION_KEY= "core:tenant_member";
const PAGE_URL = {
    TENANT_MEMBER_PAGE: "/admin/core/tenant-member"
}

export {PERMISSION_KEY, PAGE_URL}

